import React from 'react';
import Select from 'react-select';
import FormControl from 'react-bootstrap/FormControl';
import Form from 'react-bootstrap/Form';

class Scheduler extends React.Component {

  static Options = [ { label: 'Hour(s)', value: 'hr' }, { label: 'Days(s)', value: 'dd' }, 
    { label: 'Minutes(s)', value: 'mm' } ];

  constructor(props) {
    super(props);
    const execute = props.scheduler.execute !== undefined ? props.scheduler.execute : false;
    const execute_no = props.scheduler.execute_no ? props.scheduler.execute_no : '0';
    const execute_select = props.scheduler.execute_select 
      ? Scheduler.Options.find(opt => opt.value === props.scheduler.execute_select)
      : Scheduler.Options[0];
    this.state = { execute, execute_no, execute_select };
    
  }

  UNSAFE_componentWillReceiveProps(props) {
    const execute = props.scheduler.execute !== undefined ? props.scheduler.execute : false;
    const execute_no = props.scheduler.execute_no ? props.scheduler.execute_no : '';
    const execute_select = props.scheduler.execute_select 
      ? Scheduler.Options.find(opt => opt.value === props.scheduler.execute_select)
      : Scheduler.Options[0];
    this.setState({ ...this.state, execute, execute_no, execute_select });
  }

  onExecuteChange = execute => {
    const execute_no = '0';
    const execute_select = Scheduler.Options[0];
    this.setState( {...this.state, execute, execute_no, execute_select });
    this.props.onSchedulerChange(execute, execute_no, execute_select.value);
  }

  onNoChange = execute_no => {
    this.setState( {...this.state, execute_no });
    this.props.onSchedulerChange(this.state.execute, execute_no ? execute_no : '0', this.state.execute_select.value);
  }

  onSelectChange = execute_select => {
    this.setState( {...this.state, execute_select });
    this.props.onSchedulerChange(this.state.execute, this.state.execute_no ? this.state.execute_no : 0, execute_select.value);
  }

  render() {
    return (
      <>
        <div className="formhead col-md-12"> 
          <h4>Scheduled Actions</h4> { !this.props.active ? <p>Not Available in current package. Please contact support</p> : null }
          { this.props.active ?
            <Form.Check onChange={event => this.onExecuteChange(event.target.checked) } 
              checked={this.state.execute}/>
            : null
          }
        </div>
        { this.state.execute ?
          <div className="col-md-12 display-flixr">
            Execute After
            <div className='col-md-6'>
              <FormControl type="number" placeholder="Number" value={this.state.execute_no}
              onChange={ event => this.onNoChange(event.target.value) } />
            </div>
            <div className='col-md-6'>
              <Select value={this.state.execute_select} options={Scheduler.Options}
                isSearchable={false} isClearable={false}
                onChange={ execute_select => this.onSelectChange(execute_select) } />
            </div>
          </div>
        : null }
      </>
    );
  }
}
export default Scheduler;